function initAudio(stream, canvas) {
  if (!stream) {
    return;
  }
  // Step 2: 创建音频上下文
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();

  // Step 3: 创建媒体流源节点
  const source = audioContext.createMediaStreamSource(stream);

  // Step 4: 创建 AnalyserNode 并连接源节点
  const analyser = audioContext.createAnalyser();
  analyser.fftSize = 2048;
  const bufferLength = analyser.frequencyBinCount;
  const dataArray = new Uint8Array(bufferLength);
  source.connect(analyser);

  // Step 5: 绘制波形
  const ctx = canvas.getContext("2d");

  function draw() {
    const WIDTH = canvas.width;
    const HEIGHT = canvas.height;

    requestAnimationFrame(draw);

    analyser.getByteTimeDomainData(dataArray);

    ctx.fillStyle = "rgb(51, 51, 51)";
    ctx.fillRect(0, 0, WIDTH, HEIGHT);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "rgb(49, 167, 255)";

    ctx.beginPath();

    let sliceWidth = (WIDTH * 1.0) / bufferLength;
    let x = 0;

    for (let i = 0; i < bufferLength; i++) {
      let v = dataArray[i] / 128.0;
      let y = (v * HEIGHT) / 2;

      if (i === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }

      x += sliceWidth;
    }

    ctx.lineTo(canvas.width, canvas.height / 2);
    ctx.stroke();
  }
  draw();
}

export default initAudio;
